<template>
  <label
    class="font-semibold text-neutral-700 text-sm"

    :for="props.for"
  >
    <slot>
      {{ label }}
    </slot>
  </label>
</template>

<script setup lang="ts">
export interface Props {
  label?: string;
  for?: string;
}

const props = defineProps<Props>();
</script>
